(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('material-file-ibq', {
            parent: 'entity',
            url: '/material-file-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.materialFile.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/material-file/material-filesibq.html',
                    controller: 'MaterialFileIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('materialFile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('material-file-ibq-detail', {
            parent: 'material-file-ibq',
            url: '/material-file-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.materialFile.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/material-file/material-file-ibq-detail.html',
                    controller: 'MaterialFileIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('materialFile');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MaterialFile', function($stateParams, MaterialFile) {
                    return MaterialFile.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'material-file-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('material-file-ibq-detail.edit', {
            parent: 'material-file-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material-file/material-file-ibq-dialog.html',
                    controller: 'MaterialFileIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MaterialFile', function(MaterialFile) {
                            return MaterialFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('material-file-ibq.new', {
            parent: 'material-file-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material-file/material-file-ibq-dialog.html',
                    controller: 'MaterialFileIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                matlFile: null,
                                matlFileContentType: null,
                                partPath: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('material-file-ibq', null, { reload: 'material-file-ibq' });
                }, function() {
                    $state.go('material-file-ibq');
                });
            }]
        })
        .state('material-file-ibq.edit', {
            parent: 'material-file-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material-file/material-file-ibq-dialog.html',
                    controller: 'MaterialFileIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MaterialFile', function(MaterialFile) {
                            return MaterialFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('material-file-ibq', null, { reload: 'material-file-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('material-file-ibq.delete', {
            parent: 'material-file-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/material-file/material-file-ibq-delete-dialog.html',
                    controller: 'MaterialFileIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MaterialFile', function(MaterialFile) {
                            return MaterialFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('material-file-ibq', null, { reload: 'material-file-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
